import { Component, OnInit, Optional, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { SelectItem } from 'primeng/api';
import { PersonsByIdNumCtrlDig } from 'src/app/core/entities/personsByIdNumCtrlDig.model';
import * as _ from 'lodash';
import { Utils } from 'src/app/core/utils/utils';

@Component({
  selector: 'app-dialogs-tercer',
  templateUrl: './dialogs-tercer.component.html',
  styleUrls: ['./dialogs-tercer.component.css']
})
export class DialogsTercerComponent implements OnInit {

  $mostrar!: Subscription;

  loading: boolean = true;
  dboid: string = "";

  persons: PersonsByIdNumCtrlDig = new PersonsByIdNumCtrlDig();
  allPersons: PersonsByIdNumCtrlDig[] = [];

  optionsTercer: SelectItem[] = [];
  optionsTercerBase: SelectItem[] = [];

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: any,
              @Optional() private dialogRef: MatDialogRef<DialogsTercerComponent>) { }

  ngOnInit() {
    
    this.optionsTercerBase.push({ value: null, label: "" });
    this.allPersons = _.cloneDeep(this.data.personsByIdNumCtrlDig);

    for (let i = 0; i < this.allPersons.length; i++) {
      this.optionsTercerBase.push({ value: this.allPersons[i].dboid, label: this.allPersons[i].fullname });
    }

    this.optionsTercer = this.optionsTercerBase;
    this.optionsTercerBase = [];

    this.loading = false;

  }

  /**
  * @description
  * Cierra el dialog y pasa el dboid.
  */
  aceptar() {
    this.dialogRef.close(this.persons.dboid);
  }

  /**
  * @description
  * Deshabilita o habilita el botón aceptar
  */
  deshabilitar() {
    if (Utils.noUndfAndNull(this.persons.dboid) && this.persons.dboid !== "null") {
        return false;
    } else {
        return true;
    }
  }

}
